import { useState } from 'react'
import styled from 'styled-components/macro'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Keyboard } from 'swiper'
import { SwiperStyle, SliderStyle } from './MaximizedGallery.Swiper.style'
import { SwiperNav } from './MaximizedGallery.Navigation'
import { CatchSlide } from './MaximizedGallery.catch'

export const Slider = ({ initial, images }) => {
  const [activeIndex, setActiveIndex] = useState(null)

  const swiper = {
    modules: [Keyboard],
    slidesPerView: 1,
    spaceBetween: 20,
    initialSlide: initial ?? 0,
    pagination: { dynamicBullets: true },
    keyboard: { enabled: true },
    onSlideChange: (e) => setActiveIndex(e.activeIndex),
  }

  return (
    <StyleInjection>
      <SwiperContainer>
        <Swiper {...swiper} style={{ flexDirection: 'column', alignItems: 'center',
           justifyContent: 'flex-start'
            }}>
          {images?.length > 1 && <SwiperNav activeIndex={activeIndex} {...{ images }} />}
          {images?.map((img, i) => (
            <SwiperSlide
              key={i}
              style={{ transform: 'unset', backfaceVisibility: 'unset', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
               <Img src={typeof img === "string" ? img : img.url || img.Url} alt="" />
              <CatchSlide />
            </SwiperSlide>
          ))}
        </Swiper>
      </SwiperContainer>
    </StyleInjection>
  )
}

const Img = styled.img`
  border-radius: 16px;
  width: auto;
  height: auto;
  max-width: 95vw;  /* keep a little padding */
  max-height: calc(100vh - 120px);
  object-fit: contain;
  object-position: center;
  display: block;
`

const StyleInjection = styled.div`
  background-color: transparent;
  height: 100%;
  ${SwiperStyle}
  ${SliderStyle}
`

// 👇 This is where your media query logic goes
const SwiperContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .swiper-wrapper {
    height: auto  
  }
`